import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import { EventBus } from '../event-bus';

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        status: '',
        loginedNow: false,
        token: localStorage.getItem('token') || '',
        user: {
            regional: {},
            features: {},
        },

        system: {
            currencies: {},
        },

        language: localStorage.getItem('language') || 'ru',
        translations: {},

        _accounts: {
            data: [],
            cached: false,
            loaded: false,
        },
        _budgets: {
            data: [],
            cached: false,
            loaded: false,
        },
        _categories: {
            data: [],
            cached: false,
            loaded: false,
        },
        _transactions: {
            data: {},
            cached: false,
            loaded: false,
        },
        _reminders: {
            data: {},
            cached: false,
            loaded: false,
        },
    },
    mutations: {
        auth_request(state) {
            state.status = 'loading';
        },
        auth_success(state, token, user) {
            state.status = 'success';
            state.token = token;
            state.user = user;
            state.loginedNow = true;
        },
        auth_error(state) {
            state.status = 'error';
        },
        logout(state) {
            state.status = '';
            state.token = '';
        },
        initEvents(state) {
            EventBus.$on('account-added', () => this.dispatch('clearAccountsCache'));
            EventBus.$on('account-removed', () => this.dispatch('clearAccountsCache'));
            EventBus.$on('account-edited', () => this.dispatch('clearAccountsCache'));
        },
        updateUser(state, user) {
            state.user = user;
        },
        changeLang(state, lang) {
            localStorage.setItem('language', lang);
            state.language = lang;

            window.axios.defaults.headers.common['Accept-Language'] = lang;

            state.translations = JSON.parse(localStorage.getItem('translations'))[lang];
        }
    },
    actions: {
        clearAccountsCache(context) {
            this.state._accounts.cached = false;
        },

        loadUserData(context, resolve = () => {}) {
            axios.get('/user')
                .then(({data}) => {
                    this.user = data.data;

                    resolve(this.user);
                }).catch((error) => {
                    console.log(error);
                });
        },

        loadAccounts(context) {
            if(this.state._accounts.cached) {
                // return;
            }

            axios.get('/accounts').then(({data}) => {
                this.state._accounts.data = data.data;
                this.state._accounts.cached = true;
                this.state._accounts.loaded = true;
            }).catch(({response}) => {
                //
            });
        },

        loadBudgets(context) {
            if(this.state._budgets.cached) {
                // return;
            }

            axios.get('/budgets').then(({data}) => {
                this.state._budgets.data = data.data;
                this.state._budgets.cached = true;
                this.state._budgets.loaded = true;
            }).catch(({response}) => {
                //
            });
        },

        loadCategories(context) {
            if(this.state._categories.cached) {
                // return;
            }
            
            axios.get('/categories').then(({data}) => {
                this.state._categories.data = data.data;
                this.state._categories.cached = true;
                this.state._categories.loaded = true;
            }).catch(({response}) => {
                // TODO
            });
        },
        
        loadTransactions(context, {filters = {}, loaded}) {
            let _filters = new URLSearchParams(filters).toString();

            this.state._transactions.loaded = false;

            axios.get(`/transactions?${_filters}`).then(({data}) => {
                if(filters.page == 1) {
                    this.state._transactions.data = data.data;
                } else {
                    this.state._transactions.data = {...this.state._transactions.data, ...data.data};
                }

                this.state._transactions.loaded = true;
                this.state._transactions.cached = true;

                loaded();
            }).catch(({response}) => {
                this.state._transactions.loaded = true;

                // TODO
            });
        },

        loadReminders(context) {
            if(this.state._reminders.cached) {
                // return;
            }

            axios.get('/reminders').then(({data}) => {
                this.state._reminders.data = data.data;
                this.state._reminders.loaded = true;
                this.state._reminders.cached = true;
            }).catch(({response}) => {
                // TODO
            });
        },

        loadSystem(context) {
            if(localStorage.getItem('system')) {
                this.state.system = JSON.parse(localStorage.getItem('system'));

                return;
            }

            if(this.getters.isLoggedIn) {
                axios.get('/currencies')
                    .then(({data}) => {
                        this.state.system.currencies = data.data;
                        
                        localStorage.setItem('system', JSON.stringify(this.state.system));
                    });
            }
        }
    },
    modules: {
    },
    getters : {
        isLoginedNow: state => state.loginedNow,
        isLoggedIn: state => !! state.token,
        authStatus: state => state.status,

        features: state => Object.assign({}, state.user.features),
        currency: state => state.user.regional.currency,

        system: state => state.system,
        currencies: state => Object.values(state.system.currencies),

        isAccountsLoaded: state => state._accounts.loaded,
        isRemindersLoaded: state => state._reminders.loaded,
        isTransactionsLoaded: state => state._transactions.loaded,
        isCategoriesLoaded: state => state._categories.loaded,
        accounts: state => state._accounts.data,
        budgets: state => state._budgets.data,
        categories: state => state._categories.data,
        transactions: state => state._transactions.data,
        reminders: state => state._reminders.data,
    }
})
